import { Elm } from "./Main.elm";
import "./styles.css";

Elm.Main.init({ node: document.getElementById("root") });
